import { useMemo } from 'react';

// Domain
import { groupDashboardActions } from '../../../domain/dashboardAction/dashboardActionUseCase';

// Components
import Button from '../../atoms/Button/Button';

// Styles
import styles from './DashboardItemActions.module.css';

/**
 * Presentational list of dashboard action buttons, grouped by optGroup
 * @param {object} props
 * @param {Array<ApiDashboardActionItem> | null} [props.actions] - Actions to render
 * @param {(action: DashboardActionFlattened) => void} [props.onActionClick] - Click handler
 * @param {string | null} [props.pendingActionId] - ID of the action currently in flight
 * @returns {JSX.Element | null}
 */
function DashboardItemActions({
  actions = null,
  onActionClick,
  pendingActionId = null,
}) {
  const grouped = useMemo(() => groupDashboardActions(actions), [actions]);

  if (grouped.length === 0) return null;

  const isAnyPending = Boolean(pendingActionId);

  return (
    <div className={styles['dashboard-item-actions']}>
      {grouped.map((group) => (
        <div key={group.lib || 'ungrouped'} className={styles['dashboard-item-actions-group']}>
          {group.lib ? (
            <p className={styles['dashboard-item-actions-group-title']}>{group.lib}</p>
          ) : null}
          {group.options.map((action) => {
            const isThisLoading = pendingActionId === action.id;
            return (
              <div key={action.id} className={styles['dashboard-item-actions-row']}>
                <span className={styles['dashboard-item-actions-lib']}>{action.lib}</span>
                <Button
                  size="small"
                  icon={action.icon || undefined}
                  isLoading={isThisLoading}
                  disabled={isAnyPending}
                  onClick={() => onActionClick?.(action)}
                >
                  {action.buttonLib}
                </Button>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default DashboardItemActions;
